import { ParticipantPresenterProps } from 'features/ParticipantItem/types';
import { useSIPParticipant } from 'useCase/SIPTelephony/useSIPParticipant';
import { MobileSpeakerSIP } from './MobileSpeakerSIP';
import { MobileSpeakerVCS } from './MobileSpeakerVCS';

interface Props extends ParticipantPresenterProps {}

export const MobileSpeaker = (props: Props) => {
    const { checkIsSIPParticipant } = useSIPParticipant();

    const { participant } = props;
    const isSIPParticipant = checkIsSIPParticipant(participant);

    if (isSIPParticipant) {
        return <MobileSpeakerSIP {...props} />;
    }

    return <MobileSpeakerVCS {...props} />;
};
